import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CompleteCancelModalModel } from '@common/models/CompleteCancel.modal.model';
import { normalizeApiDateTime } from '@common/utils/normalize-api-datetime';
import { requiredValidator } from '@common/validators/required-validator';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-complete-cancel-modal.component',
    templateUrl: './complete-cancel-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompleteCancelModalComponent implements OnInit, OnDestroy {
    public title: string;
    public message: string;
    public action: 'Complete' | 'Cancel' | 'Confirm';
    public showDate: boolean;
    public showRemark: boolean;
    public requireRemark: boolean;
    public dateLabel: string;
    public remarkLabel: string;
    public initialDate?: Date;

    model: CompleteCancelModalModel = new CompleteCancelModalModel();
    form: UntypedFormGroup;

    destroyed$ = new Subject<void>();

    constructor(public activeModal: DialogRef) {}

    ngOnInit(): void {
        this.form = this.model.createFormGroup();

        const remarkControl = this.form.get('remark');

        if (this.initialDate) {
            this.form.get('date')?.setValue(this.initialDate);
        }

        if (!this.showDate) {
            this.form.get('date')?.disable();
        }

        if (!this.showRemark) {
            remarkControl?.disable();
        } else if (this.requireRemark) {
            remarkControl?.setValidators([requiredValidator()]);
            remarkControl?.updateValueAndValidity();
        }
    }

    submitAction(): void {
        if (!this.form.valid) {
            return;
        }

        const rawValue = this.form.getRawValue();
        rawValue.date = normalizeApiDateTime(rawValue.date);

        if (typeof rawValue.remark === 'string') {
            rawValue.remark = rawValue.remark.trim();
        }

        this.activeModal.close(rawValue);
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
